var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"themes"},_vm._l((_vm.themes),function(theme){return _c('ButtonTheme',{key:theme.name,attrs:{"theme":theme}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }